/**
 * Created by staffanrantzow on 14/06/16.
 */

class IncomeStatementEntity {

  constructor (
    id,
    url,
    userId,
    year
  ) {
    this.id = id;
    this.url = url;
    this.userId = userId;
    this.year = year;
    this.name = year; // used for select
    this.value = id; // used for select
  }

}

export default IncomeStatementEntity;



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/income-statements/incoment-statement-entity.js
 **/